module.exports = __webpack_public_path__ + "static/media/trabajo equipo.68c0c44b.jpg";